import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DocumentSearchCriteria, IAttachment, ITcmModel } from "@tylertech/tyler-api-types";
import { AttachmentModel } from "../interfaces";
import { AttachmentDialogComponent, AttachmentsDialogData } from "./dialog";

@Injectable()
export class AttachmentsDialogService
{
    private readonly matDialog = inject(MatDialog);


    showBySearchCriteria(
        documentSearchCriteria: DocumentSearchCriteria,
        isAdd?: boolean,
        readOnly?: boolean,
        docType?: string
    ): Promise<AttachmentModel[]>
    {
        const dialogConfig: MatDialogConfig<AttachmentsDialogData> = {
            width: "80vw",
            data: {
                entityId: documentSearchCriteria.EntityId,
                entityType: documentSearchCriteria.EntityType,
                isAdd,
                tcmEntity: documentSearchCriteria.Entity,
                attachments: undefined,
                readOnly,
                docType
            }
        };
        const dialogRef = this.matDialog.open(AttachmentDialogComponent, dialogConfig);

        return dialogRef.afterClosed()
            .toPromise();
    }

    show(
        entityId: string,
        entityType: string,
        isAdd: boolean,
        tcmEntity?: ITcmModel,
        attachments?: IAttachment[],
        readOnly?: boolean,
        docType?: string
    ): Promise<AttachmentModel[]>
    {
        const dialogConfig: MatDialogConfig<AttachmentsDialogData> = {
            width: "80vw",
            data: {
                entityId,
                entityType,
                isAdd,
                tcmEntity,
                attachments,
                readOnly,
                docType
            }
        };
        const dialogRef = this.matDialog.open(AttachmentDialogComponent, dialogConfig);

        return dialogRef.afterClosed()
            .toPromise();
    }
}
